"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printFooterRangeTranslations = {
    "en": {
        report: "Report",
        for: "for",
        historicalReport: "Historical Report",
        activeReport: "Active Report",
    },
    "de": {
        for: "für",
        report: "Bericht",
        historicalReport: "Historischer Bericht",
        activeReport: "Aktiver Bericht",
    },
    "nl": {
        for: "voor",
        report: "Rapport",
        historicalReport: "Historisch rapport",
        activeReport: "Actief rapport",
    },
    "it": {
        for: "per",
        report: "Rapporto",
        historicalReport: "Statistiche storico",
        activeReport: "Statistiche correnti",
    },
    "fr": {
        for: "pour",
        report: "Rapport",
        historicalReport: "Rapport historique",
        activeReport: "Rapport actif",
    },
    "es": {
        for: "para",
        report: "Informe",
        historicalReport: "Informe histórico",
        activeReport: "Informe activo",
    },
    "ja": {
        for: "対象",
        report: "報告書",
        historicalReport: "履歴レポート",
        activeReport: "アクティブレポート",
    },
    "en-GB": {
        for: "for",
        report: "Report",
        historicalReport: "Historical Report",
        activeReport: "Active Report",
    },
    "ru": {
        report: "Отчет",
        for: "для",
        historicalReport: "Активный Отчет",
        activeReport: "Выбрать агента",
    },
};
